var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogOutSharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 13.539,
    viewBox: "0 0 16 13.539",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3c2f87",
    transform: "matrix(-1 0 0 -1 19.376 19.164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.683 11.779h6.154v-5.539a.615.615 0 0 0 -.615-.615h-9.232a.615.615 0 0 0 -.615.615v12.309a.615.615 0 0 0 .615.615h9.231a.615.615 0 0 0 .615-.615v-5.539h-6.153z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.858 14.3-3.512-3.512-.87.87 2.462 2.462h-3.438v1.231h3.438l-2.462 2.462.87.87 3.512-3.512a.615.615 0 0 0 0-.871z",
    transform: "translate(-8.663 -2.337)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOutSharp);
export default __webpack_public_path__ + "static/media/log-out-sharp.922c1707fd04be6c9209983444fe08e6.svg";
export { ForwardRef as ReactComponent };